<!-- 顶栏右侧区域按钮 -->
<template>
  <div class="ele-admin-header-tool">
    <!-- 全屏切换 -->
    <!-- <div
      class="ele-admin-header-tool-item hidden-xs-only"
      @click="changeFullscreen"
    >
      <i
        :class="fullscreen ? 'el-icon-_screen-restore' : 'el-icon-_screen-full'"
      ></i>
    </div> -->
    <!-- 国际化切换 -->
    <div class="custom__tool-item">
      <languageVue @changeLanguage="changeLanguage" />
    </div>
    <!-- 消息通知 -->
    <!-- <div class="custom__tool-item">
      <ele-notice />
    </div> -->
    <!-- 用户信息 -->
    <div class="custom__tool-item">
      <el-dropdown @command="onUserDropClick" placement="bottom">
        <div class="custom__header-avatar">
          <!-- <el-avatar :src="getFileAccessHttpUrl(loginUser.avatar) || defaultAvatar" /> -->
          <el-avatar :src="loginUser.avatar || defaultAvatar" />
          <div class="custom__header-avatar-name">
            <span class="hidden-xs-only">{{ loginUser.memberName }}</span>
            <span class="hidden-sm-only">{{
              'ID: ' + loginUser.memberId
            }}</span>
          </div>
          <div class="custom__header-avatar-arrow"></div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="profile" icon="el-icon-user" v-if="loginType == '2'">
            {{ $t('common.setting') }}
          </el-dropdown-item> -->
          <el-dropdown-item command="setting" icon="el-icon-setting">
            {{ $t('common.setting') }}
          </el-dropdown-item>
          <el-dropdown-item
            command="logout"
            icon="el-icon-switch-button"
            divided
          >
            {{ $t('common.signOut') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 主题设置 -->
    <!-- <div v-if="setting" class="custom__tool-item" @click="openSetting">
      <i class="el-icon-_more"></i>
    </div> -->
  </div>
</template>

<script>
  import languageVue from './language';
  import { removeToken } from '@/utils/token-util';
  import { getFileAccessHttpUrl } from '@/utils/utils';
  import { USER_LOGIN_TYPE } from '@/config/setting';

  export default {
    name: 'EleHeaderRight',
    data() {
      return {
        defaultAvatar:
          'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        loginType: localStorage.getItem(USER_LOGIN_TYPE) || '2'
      };
    },
    components: { languageVue },
    emits: ['item-click', 'change-language', 'change-fullscreen'],
    props: {
      // 是否显示设置按钮
      setting: Boolean,
      // 是否是全屏状态
      fullscreen: Boolean
    },
    computed: {
      // 当前用户信息
      loginUser() {
        return this.$store.state.user.showUserInfo;
      }
    },
    methods: {
      getFileAccessHttpUrl,
      /* 用户信息下拉点击事件 */
      onUserDropClick(command) {
        if (command === 'password') {
          this.$emit('item-click', 'password');
        } else if (command === 'profile') {
          if (this.$route.fullPath !== '/user/profile') {
            this.$router.push('/user/profile');
          }
        } else if (command == 'setting') {
          this.$emit('showSet-click');
        } else if (command === 'logout') {
          // 退出登录
          this.$confirm(
            this.$t('common.confirmLogout'),
            this.$t('common.confirm'),
            {
              type: 'warning',
              customClass:
                this.$i18n.locale === 'ar' ? 'force-left-message' : ''
            }
          )
            .then(() => {
              removeToken();
              location.replace('/login'); // 这样跳转避免再次登录重复注册动态路由
            })
            .catch(() => {});
        }
      },
      /* 打开设置抽屉 */
      openSetting() {
        this.$emit('item-click', 'setting');
      },
      /* 全屏切换 */
      changeFullscreen() {
        this.$emit('change-fullscreen');
      },
      /* 切换语言 */
      changeLanguage(lang) {
        this.$emit('change-language', lang);
      }
    }
  };
</script>
<style lang="scss">
  .force-left-message .el-message-box__container {
    text-align: right !important;
    direction: rtl !important;
  }
  .force-left-message .el-message-box__message {
    padding-inline-start: 30px !important;
    padding-inline-end: 30px !important;
  }
</style>

<style lang="scss" scoped>
  .custom__header-avatar {
    display: flex;
    align-items: center;
    background: #e9ecf4;
    border-radius: 8px;
    padding: 6px 14px 6px 19px;
    margin-inline-end: 46px;
    ::v-deep .el-avatar {
      width: 0.2rem !important;
      height: 0.2rem !important;
      border-radius: 50% !important;
      margin-inline-end: 0.08854rem !important;
    }
    &-name {
      display: flex;
      flex-direction: column;
      color: #1f1f1f !important;
      span {
        margin-inline-end: 24px !important;
      }
      span:nth-child(1) {
        font-family: 'MediumFont', 'Noto Sans', 'Arial', sans-serif;
        font-size: 20px !important;
      }
      span:nth-child(2) {
        font-family: 'RegularFont', 'Noto Sans', 'Arial', sans-serif;
        font-size: 16px !important;
      }
    }
    &-arrow {
      width: 14px;
      height: 8px;
      background: url('~@/assets/images/menu/arrow.png') no-repeat;
      background-size: 100% 100%;
    }
  }
</style>
